import { styled } from 'styled-components';

export const PaginationDropdownStyled = styled.div`
  && button {
    box-shadow: none;
    min-width: unset;
  }
`;
